import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  VideoPlayerDefinition,
  VideoPlayerPlatformProps,
} from '../VideoPlayer.types';
import { props as viewerPropsMapper } from './VideoPlayer.mapper';

const props = composeMapper<
  PreviewWrapperProps<VideoPlayerPlatformProps>,
  VideoPlayerDefinition
>()(
  viewerPropsMapper,
  { add: ['isPlayingAllowed', 'shouldResetComponent'] },
  (resolver, deps, carmiData) => {
    const viewerProps = viewerPropsMapper.resolver(deps, carmiData);
    const { isPlayingAllowed, shouldResetComponent } = deps;
    return {
      ...viewerProps,
      previewWrapperProps: {
        isPlayingAllowed,
        shouldResetComponent,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
